import dayjs, { Dayjs } from "dayjs";

export function getControlEndDisabledDate(startDate?: Date | string | null) {
  return (current: Dayjs) =>
    !!startDate && !!current && current.isBefore(dayjs(startDate), "day");
}

export function getControlEndDisabledTime(startDate?: Date | string | null) {
  return (current: Dayjs | null) => {
    if (!startDate || !current) {
      return {};
    }

    const start = dayjs(startDate);
    if (!current.isSame(start, "day")) {
      return {};
    }

    const startHour = start.hour();
    const startMinute = start.minute();

    return {
      disabledHours: () => Array.from({ length: startHour }, (_, hour) => hour),
      disabledMinutes: (selectedHour: number) => {
        if (selectedHour < startHour) {
          return Array.from({ length: 60 }, (_, minute) => minute);
        }
        if (selectedHour > startHour) {
          return [];
        }
        return Array.from({ length: startMinute + 1 }, (_, minute) => minute);
      },
    };
  };
}
